<template>
  <base-form :title="$t('settings.siteAdmins.create.title')"
             @submit.prevent="onFormSubmit"
             :loading="loading"
             class="site-admins-create">
    <fg-input :label="$t('generic.role')"
              required
              :error="getError($t('generic.role'))">
      <role-autocomplete v-model="model.role"
                         filter-query="admin"
                         exclude-query="admin-super-admin"
                         class="role-select"
                         :name="$t('generic.role')"
                         v-validate="modelValidations.role">
      </role-autocomplete>
    </fg-input>

    <fg-input :placeholder="$t('settings.siteAdmins.create.email')"
              required
              :name="$t('settings.siteAdmins.create.email')"
              :error="getError($t('settings.siteAdmins.create.email'))"
              :label="$t('settings.siteAdmins.create.email')"
              v-validate="modelValidations.email"
              v-model="model.email">
    </fg-input>

    <fg-input :placeholder="$t('settings.siteAdmins.create.givenName')"
              required
              :name="$t('settings.siteAdmins.create.givenName')"
              :error="getError($t('settings.siteAdmins.create.givenName'))"
              :label="$t('settings.siteAdmins.create.givenName')"
              v-validate="modelValidations.given_name"
              v-model="model.given_name">
    </fg-input>

    <fg-input :placeholder="$t('settings.siteAdmins.create.familyName')"
              required
              :name="$t('settings.siteAdmins.create.familyName')"
              :error="getError($t('settings.siteAdmins.create.familyName'))"
              :label="$t('settings.siteAdmins.create.familyName')"
              v-validate="modelValidations.family_name"
              v-model="model.family_name">
    </fg-input>

  </base-form>
</template>
<script>
  import RoleAutocomplete from 'src/components/Autocomplete/RoleAutocomplete'
  import SiteAdminService from 'src/services/SiteAdminService'
  import { getRouteName, routeTypes } from 'src/config/routeTypes'
  import entities from 'src/config/entities'
  export default {
    name: 'site-admins-add',
    components: {
      RoleAutocomplete
    },
    data () {
      return {
        model: {
          role: {},
          given_name: '',
          email: '',
          family_name: ''
        },
        loading: false
      }
    },
    computed: {
      modelValidations () {
        return {
          role: {
            required: true
          },
          given_name: {
            required: true,
            min: 2
          },
          family_name: {
            required: true,
            min: 2
          },
          email: {
            required: true,
            email: true
          }
        }
      }

    },
    methods: {
      async onFormSubmit () {
        let result = await this.$validator.validateAll()
        if (!result) return
        try {
          this.loading = true;
          await SiteAdminService.create({
            ...this.model,
            role: this.model.role.name
          })
          this.$router.push('/settings/site-admins')
        } finally {
          this.loading = false;
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .site-admins-create {
    .role-select /deep/ .el-select {
      width: 100%;
      max-width: 100%;
    }
  }
</style>
